<!-- eslint-disable vue/no-multiple-template-root -->
<template>
  <div id="observer-root" class="observation" :style="{backgroundColor: backgroundColor}">
    <Head>
      <Title>{{ formattedMetaTitle }}</Title>
      <Meta name="description" hid="description" :content="pageData.pageDescription" />
      <Meta name="og:image" hid="og:image" :content="OG_IMAGE" />
      <Meta name="og:title" hid="og:title" :content="formattedMetaTitle" />
      <Meta name="robots" hid="index" :content="pageData.isIndexed ? 'index follow' : 'noindex'" />
    </Head>
    <BlocksNewHomeHero v-bind="hero[0]" />
    <BlocksNewContentLayout :content="content" />
  </div>
</template>
<script setup>
import { DIASPORA_START_PAGE_QUERY } from '@/utils/graphql-queries'
import { OG_IMAGE } from '@/utils/resources'
const { $env } = useNuxtApp()

const datoHelperClient = useDatoHelper()

definePageMeta({
  stopDefaultSwitch: true,
  key: route => route.params.country
})
const { setLocale } = useI18n()
const { $bus, $mRouter } = useNuxtApp()
const currentLocale = useLocale() || 'en'
const route = useRoute()

const backgroundColor = ref('black')

const content = ref([])

const hero = ref({})

const alternativeSlugs = ref(null)

const pageData = ref({})

const countrySlug = route.params.country

// If the country slug contains other characters than alphabetic characters and/or dashes, abort and throw an error 404
const slugContainsWeirdChars = !countrySlug.normalize('NFD').replace(/[\u0300-\u036F]/g, '').match(/^[a-zA-Z\-]+$/g)
if (slugContainsWeirdChars) {
  throw createError({
    statusCode: 404
  })
}
const query = `query MyQuery {
      country: diasporaStartPage(locale: ${currentLocale}, filter: {slug: {eq: "${countrySlug}"}}) {
          ${DIASPORA_START_PAGE_QUERY}
      }
      default: diasporaStartPage(locale: ${currentLocale}, filter: {slug: {eq: "default"}}) {
          ${DIASPORA_START_PAGE_QUERY}
      }
    }`

const response = await datoHelperClient.request(query, 'diasporaPages' + countrySlug + currentLocale)

if (response.country) {
  pageData.value = response.country

  // Case: alterntiveSlugs exist for the country. We use the alternativeSlugs defined in the CMS.
  alternativeSlugs.value = response.country.alternativeSlugs ? response.country.alternativeSlugs[0] : null
} else {
  pageData.value = response.default
}
if (!$env.isProduction) {
  pageData.value.isIndexed = false
}
hero.value = pageData.value.hero
content.value = pageData.value.content

// Case: country does not have alternativeSlugs because it uses the default page from CMS. So we query the countries api to fetch the list.
const country = await useCountries().getCountryBySlug(countrySlug)

if (!alternativeSlugs.value && country) {
  alternativeSlugs.value = country.alternativeSlugs
}

const insertCountryName = (text) => {
  if (country) {
    return text.replace(/{country}/g, country.name)
  }
  return text.replace(/{country}/g, countrySlug)
}

const formattedMetaTitle = computed(() => {
  if (pageData.value.pageTitle) {
    return insertCountryName(pageData.value.pageTitle)
  }
  return null
})
const handleLocaleSwitch = async (val) => {
  let country
  // if mode = 1, switch between country pages. if mode = 0, use for global page to go home.
  let mode = 0

  if (val.destinationCountry) {
    country = await useCountries().getCountry(val.destinationCountry)
    mode = 1
  }

  const countrySlug = country ? country.alternativeSlugs[val.destinationLocale] : alternativeSlugs.value[val.destinationLocale]

  setLocale(val.destinationLocale).then(() => {
    if (mode === 1) {
      window.location.href = $mRouter.getLocalRoute({ name: 'country', params: { country: countrySlug } }).href
    } else {
      window.location.href = $mRouter.getLocalRoute({ name: 'index' }).href
    }
  })
}

$bus.onDynamicRouteChangeLanguage(route.meta.key, handleLocaleSwitch)

</script>
  <style scoped>
  .observation {
    transition: background-color 0.5s ease;
    -webkit-transition: background-color 0.5es ease;
  }
  </style>
